import { uniqBy, xorBy } from 'lodash';
import { initialState } from './useWizardState';
import {
  ON_CLICK_PROJECT,
  RESET_WIZARD_STATE,
  FETCH_PROJECT_TEAMS,
  TOGGLE_ACTION_LOADING,
  FETCH_TEAM_AREAS,
  ON_CLICK_TEAM,
  ON_CLOSE_TEAM_WIZARD,
  ON_CLOSE_AREAS_WIZARD,
  OPEN_WIZARD,
  CLOSE_WIZARD,
  TOGGLE_AREA_CHECKBOX,
  ON_FINISH_WIZARD_SELECTION,
  ON_DELETE_SELECTED_VALUE_BY_IDX,
  ON_CLICK_EDIT_IDX,
  ON_EDIT_SELECTED_VALUE,
  TOGGLE_AREA_CHECKBOX_ALL,
  SET_PROJECTS,
  FETCH_PROJECT_AREAS
} from './wizard.state.actions';

const wizardStateReducer = (state, action) => {
  const { idxOnEdit } = state;
  const isEditMode = idxOnEdit !== null;

  let teamAreasIds = [];

  switch (action.type) {
    case RESET_WIZARD_STATE:
      return initialState;

    case OPEN_WIZARD:
      return { ...state, isWizardOpen: true };
    case CLOSE_WIZARD:
      return { ...state, isWizardOpen: false, idxOnEdit: null };

    case SET_PROJECTS:
      return { ...state, projects: action.payload };
    case ON_CLICK_PROJECT:
      return {
        ...state,
        selectedProject: action.payload,
        selectedTeam: null,
        projectTeams: []
      };
    case ON_CLICK_TEAM:
      return {
        ...state,
        selectedTeam: action.payload,
        selectedAreas: []
      };
    case TOGGLE_AREA_CHECKBOX:
      return {
        ...state,
        selectedAreas: xorBy(state.selectedAreas, [action.payload], 'id')
      };
    case TOGGLE_AREA_CHECKBOX_ALL:
      teamAreasIds = state.teamAreas.map(area => area.id);
      const additionalAreas = state.projectAreas.filter(
        area => !teamAreasIds.includes(area.id)
      );
      const additionalAreasIds = additionalAreas.map(area => area.id);
      const isSelectAll = !!action.payload;
      return {
        ...state,
        selectedAreas: isSelectAll
          ? uniqBy([...state.selectedAreas, ...additionalAreas], 'id')
          : state.selectedAreas.filter(
              area => !additionalAreasIds.includes(area.id)
            )
      };
    case ON_FINISH_WIZARD_SELECTION:
      return {
        ...state,
        selectedValues: isEditMode
          ? state.selectedValues.map((selectedValue, idx) =>
              idx === idxOnEdit ? action.payload : selectedValue
            )
          : [...state.selectedValues, action.payload],
        idxOnEdit: null,
        selectedProject: null,
        selectedTeam: null,
        projectTeams: [],
        teamAreas: [],
        selectedAreas: [],
        loadingActions: {},
        isWizardOpen: false
      };
    case ON_DELETE_SELECTED_VALUE_BY_IDX:
      return {
        ...state,
        selectedValues: state.selectedValues.filter(
          (_, idx) => idx !== action.payload
        )
      };
    case ON_CLICK_EDIT_IDX:
      return { ...state, idxOnEdit: action.payload };
    case ON_EDIT_SELECTED_VALUE:
      return {
        ...state,
        selectedProject: action.payload.project,
        selectedTeam: action.payload.team,
        selectedAreas: action.payload.areas,
        isWizardOpen: true
      };

    case ON_CLOSE_TEAM_WIZARD:
      return { ...state, selectedProject: null };
    case ON_CLOSE_AREAS_WIZARD:
      return { ...state, selectedTeam: null };

    case FETCH_PROJECT_TEAMS:
      return { ...state, projectTeams: action.payload };
    case FETCH_PROJECT_AREAS:
      return { ...state, projectAreas: action.payload };
    case FETCH_TEAM_AREAS:
      teamAreasIds = action.payload.map(area => area.id);
      return {
        ...state,
        teamAreas: action.payload,
        selectedAreas: state.selectedAreas.filter(
          area => !teamAreasIds.includes(area.id)
        )
      };
    case TOGGLE_ACTION_LOADING:
      const { loadingActions } = state;
      const [currAction, isLoading] = action.payload;
      const loadingCounter =
        Number(loadingActions[currAction] || 0) + Number(isLoading ? 1 : -1);
      const newLoadingActions = {
        ...loadingActions,
        [currAction]: loadingCounter
      };
      return { ...state, loadingActions: newLoadingActions };

    default:
      return state;
  }
};

export default wizardStateReducer;
